import { createGlobalStyle } from "styled-components"

export const GlobalStyles = createGlobalStyle`
  p {
    margin-bottom: 8px;
  }
`
